import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class MwPhoneInputService {
  private flagIconsLoaded = false;

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {}

  loadFlagIcons(): void {
    if (this.flagIconsLoaded) {
      return;
    }
    this.iconRegistry.addSvgIconSetInNamespace(
      'mw-flags-set',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `assets/icons/mw-flags-set.svg`
      )
    );
    this.flagIconsLoaded = true;
  }
}
